import kebabCase from "lodash-es/kebabCase";

export function toCssVar(val, identifier) {
  return `--${identifier}-${kebabCase(val)}`;
}
